import IndustryChecklistI18n from "@/components/landing/shared/IndustryChecklistI18n";
const ChecklistVerbaendeSection = () => <IndustryChecklistI18n translationPrefix="industryVerbaende" />;
export default ChecklistVerbaendeSection;
